import { render, staticRenderFns } from "./reportdatamanage.vue?vue&type=template&id=29587252&scoped=true&"
import script from "./reportdatamanage.vue?vue&type=script&lang=js&"
export * from "./reportdatamanage.vue?vue&type=script&lang=js&"
import style0 from "./reportdatamanage.vue?vue&type=style&index=0&id=29587252&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29587252",
  null
  
)

export default component.exports